module.exports = __webpack_public_path__ + "img/simple-prem-logo.4387a57a.svg";